import React, {ReactNode, useRef} from 'react';
import InnerPop from '../../../newPopup/innerPop/InnerPop';
import * as css from './SendingModalWrapper.css';
import {TShow} from '../../../prompotionPopup/PromotionPopup';
import CustomScrollbar from '../../../customScrollbar/CustomScrollbar';

interface ButtonConfig {
    text: string;
    onClick: () => void;
    disabled?: boolean;
}

interface ButtonsConfig {
    whiteBtn?: ButtonConfig;
    blueBtn?: ButtonConfig;
}

interface BaseModalProps {
    show: TShow;
    title: string;
    buttons: ButtonsConfig;
    dataCy: string;
    children: ReactNode;
    headerImage?: string;
    headerHeight?: 'short' | 'tall';
}

function SendingModalWrapper({show, title, buttons, dataCy, children, headerImage, headerHeight = 'short'}: BaseModalProps) {
    const refContent = useRef(null);
    return (
        <css.container
            onClick={(e) => e.stopPropagation()}
            onMouseUp={(e) => e.stopPropagation()}
        >
            <InnerPop 
                show={show}
                title={title}
                buttons={buttons}
                dataCy={dataCy}
            >
                <css.headerContent $headerHeight={headerHeight} $headerImage={headerImage}>
                    <css.headerTitle>{title}</css.headerTitle>
                </css.headerContent>
                <CustomScrollbar contentRef={refContent} cssStyle={''} maxBottom={65} />
                <css.mainContent ref={refContent}>
                    {children}
                </css.mainContent>
            </InnerPop>
        </css.container>
    );
}

export default SendingModalWrapper;
